import { Component } from "@angular/core";

@Component({
  selector: "app-icon-search",
  imports: [],
  templateUrl: "./icon-search.component.html",
  styleUrl: "./icon-search.component.scss",
})
export class IconSearchComponent {}
